import { singleton } from "aurelia-dependency-injection";

declare let version: string;
declare let useApiConfig: boolean;
declare let onboardingRequestPlugins: OnboardingRequestPluginsModel;

@singleton()
export class ConfigService {

    private static _singleton: ConfigService;
    public config: ConfigModel;

    constructor() {
        if (!ConfigService._singleton) {
            ConfigService._singleton = this;
        }
    }

    async init() {
        let response = null;
        if (typeof useApiConfig !== 'undefined' && useApiConfig == true) {
            response = await fetch('config');
        }
        else {
            response = await fetch('config.json');
        }
        this.config = await response.json()
        this.config.version = version;
        if (typeof onboardingRequestPlugins !== 'undefined') {
            this.config.onboardingRequestPlugins = onboardingRequestPlugins;
        }
        const urlOverrides = window["urlOverrides"];
        if (urlOverrides) {
            for (const key in urlOverrides) {
                this.config.urls[key] = urlOverrides[key];
            }
        }
    }

    //For accessing the instance from static methods
    static instance(): ConfigService {
        return this._singleton;
    }
}

export interface ConfigModel {
    name: string;
    version: string;
    environment: string;
    common: CommonModel;
    settings: SettingsModel;
    urls: UrlsModel;
    analytics: AnalyticsModel;
    onboardingRequestPlugins: OnboardingRequestPluginsModel;
    inspectionSettings: InspectionResourceModel;
}

export interface InspectionResourceModel {
    causationTreeUrl: string;
    causationTreeThumbnailUrl: string;
}

export interface UrlsModel {
    rightShipPlatformUrl: string;
    rightShipPlatformApiUrl: string;
    dueDiligenceApiUrl: string;
    rightShipSignupUrl: string;
    myVesselsUrl: string;
    rightShipForDevelopersUrl: string;
    rightShipForDevelopersApiUrl: string;
    rightStoreApiUrl: string;
    rightStoreUrl: string;
    rightStoreTopupsUrl: string;
    rightShipInspectionUrl: string;
    myVesselsApiUrl: string;
    tasksUrl: string;
    pscUrl: string;
    crewWelfareApiUrl: string;
    blobStorageUrl: string;
    rightStoreRefundUrl: string;
    rightStoreRightshipSubscriptionUrl: string;
    vesselHealthReviewUrl: string;
    contactForFullSubscriptionUrl: string;
    crewWelfareUrl: string;
    redMarbleUrl: string;
    leafletMapTilesUrl: string;
    rightShipODataApiUrl: string;
    technicalInformationUrl: string;
    pscRiskIqUrl: string;
    pscRiskIqApiUrl: string;
    aboutMessageCenterUrl?: string;
    documentManagementApiUrl: string;
    messageCenterHelpUrl: string;
    learnMoreUrl: string;
    revisedInspectionAgeTriggerUrl: string;
    rightShipSignupApiUrl: string;
    fleetFocusApiUrl: string;
}

export interface CommonModel {
    defaultDateFormat: string;
    defaultTimeFormat: string;
    defaultDateTimeFormat: string;
    defaultNotificationTimeout: number;
    auth0Settings: Auth0Model;
    defaultStorageContainer: string;
}

export interface SettingsModel {
    redirectInspectionLinkToMicrosite: boolean;
    signalRLimitAttempts: number;
    rightshipInspectionEmail: string;
    showSireTableInVetCriteria: boolean;
    amChartsLicense: string;
    intercomAppId: string;
    leafletAccessToken: string;
    maximumAmountOfProposalEstimatedCost: number;
    messageCenterOn: boolean;
    defaultAIClassificationOn: boolean;
    enableVesselAffectedAgeChangeLabel: boolean;
}

export interface AnalyticsModel {
    googleAnalytics: GoogleAnalyticsConfig,
    dataDog: DataDogConfig;
    azureAppInsights: AzureAppInsightsConfig;
}

export interface GoogleAnalyticsConfig {
    tagManagerKey: string;
    analyticsApiKey: string;
}

export interface AzureAppInsightsConfig {
    instrumentationKey: string;
}

export interface DataDogConfig {
    clientToken: string;
    applicationId: string;
    sessionSampleRate: number;
    sessionReplaySampleRate: number;
    service: string;
    environment: string;
}

export interface Auth0Model {
    domain: string;
    clientId: string;
    redirectUri: string;
    connection: string;
    audience: string;
    loginPath: string;
}

export interface OnboardingRequestPluginsModel {
    [pluginName: string]: OnboardingRequestPluginModel
}

export interface OnboardingRequestPluginModel {
    landingPages: OnboardingLandingPageModel[];
    sections: string[];
}

export interface OnboardingLandingPageModel {
    landingPage: string;
    completeOnboardingPages: string[];
}